/**
 * @file_purpose  component created for footer of page
 * @author Swarnali Ghosh
 * @Date_Created 28-02-2024
 * @Date_Modified 01-03-2024
 */

import React from 'react'
import MAINLOGO from '../../assets/images/plexlogo.png'

const Footer = () => {
    return (
        <>
            <div className='container'>
                <div className='row'>
                    <div className='col-sm-12'>
                        <div className='footer'>
                            <p className="copyright">Copyright @2026 SLOTSDIAMOND 3. All rights reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer
